import { DialogRef } from '@angular/cdk/dialog';
import { take } from 'rxjs/operators';
import { lastValueFrom } from 'rxjs';

export const getDialogResult = <T = any, T2 = any>(
  dialogRef: DialogRef<any, any>
) => lastValueFrom(
  dialogRef.closed.pipe(take(1))
) as Promise<T>;
